import { render } from "./RoleChange.vue?vue&type=template&id=afc6c58c&scoped=true"
import script from "./RoleChange.vue?vue&type=script&lang=js"
export * from "./RoleChange.vue?vue&type=script&lang=js"

import "./RoleChange.vue?vue&type=style&index=0&id=afc6c58c&lang=css"
import "./RoleChange.vue?vue&type=style&index=1&id=afc6c58c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afc6c58c"]])

export default __exports__